import React, { ReactNode } from 'react';
import {
  Popover,
  PopoverTrigger,
  Icon,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  Text,
} from '@tonic-ui/react';
import { IconButton } from '../icon-button';

interface InfoPopoverProps {
  title?: ReactNode;
  body: ReactNode;
  placement?: string;
  popoverIcon?: string;
}

const InfoPopover = ({
  title,
  body,
  placement = 'right',
  popoverIcon = 'info-o',
}: InfoPopoverProps): JSX.Element => {
  return (
    <Popover placement={placement}>
      <PopoverTrigger>
        <IconButton>
          <Icon icon={popoverIcon} />
        </IconButton>
      </PopoverTrigger>
      <PopoverContent>
        {title && (
          <PopoverHeader>
            <Text size="md" fontWeight="bold">
              {title}
            </Text>
          </PopoverHeader>
        )}
        <PopoverBody>{body}</PopoverBody>
      </PopoverContent>
    </Popover>
  );
};

export default InfoPopover;
